var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 45,
    viewBox: "0 0 32 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6086 20.0838C12.7746 21.2316 14.3544 21.875 16 21.875C16.815 21.875 17.6222 21.717 18.3755 21.4098C19.1289 21.1026 19.814 20.6522 20.3914 20.0838C20.9688 19.5154 21.4272 18.8402 21.7402 18.0965C22.0531 17.3528 22.2143 16.5554 22.2143 15.75C22.2143 14.123 21.5576 12.5642 20.3914 11.4162C19.2254 10.2684 17.6456 9.625 16 9.625C14.3544 9.625 12.7746 10.2684 11.6086 11.4162C10.4424 12.5642 9.78572 14.123 9.78572 15.75C9.78572 17.377 10.4424 18.9358 11.6086 20.0838ZM16 44.2516C15.9109 44.1512 15.8067 44.0331 15.6887 43.8984C15.2541 43.4017 14.6323 42.6782 13.8858 41.7728C12.3923 39.9613 10.4019 37.4246 8.41242 34.522C6.422 31.618 4.43895 28.357 2.95509 25.0966C1.46816 21.8294 0.5 18.6004 0.5 15.75C0.5 11.708 2.13109 7.82995 5.03705 4.96939C7.94328 2.10857 11.8866 0.5 16 0.5C20.1134 0.5 24.0567 2.10857 26.9629 4.96939C29.8689 7.82995 31.5 11.708 31.5 15.75C31.5 18.6004 30.5318 21.8294 29.0449 25.0966C27.561 28.357 25.578 31.618 23.5876 34.522C21.5981 37.4246 19.6077 39.9613 18.1142 41.7728C17.3677 42.6782 16.7459 43.4017 16.3113 43.8984C16.1933 44.0331 16.0891 44.1512 16 44.2516Z",
    fill: "#034A73",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/location_pin.2255181d8f2fdb02262bc429df9278e3.svg";
export { ForwardRef as ReactComponent };